import * as React from 'react';
import { styled } from '@mui/material';

export const DropIndicator = ({
    dropPosition,
    dropLevelOffset,
    indent,
}: DropIndicatorProps) => {
    const style: React.CSSProperties = {};
    switch (dropPosition) {
        case -1:
            style.top = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 1:
            style.bottom = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 0:
            style.bottom = 0;
            style.left = indent;
            break;
    }
    return <Root style={style} />;
};

const Root = styled('div', {
    name: 'RaDropIndicator',
    overridesResolver: (props, styles) => styles.root,
})(({ theme }) => ({
    pointerEvents: 'none',
    position: 'absolute',
    right: 0,
    backgroundColor: theme.palette.secondary.main,
    height: 2,
}));

export interface DropIndicatorProps {
    dropPosition: -1 | 0 | 1;
    dropLevelOffset: number;
    indent: number;
}
